import * as Html from "../../util/Html.ts";

export {init}
Html.registerWidget('widget/form/focusme',{init:init})

function init(obj){
  obj.focus();
}